import {
  TouchableOpacity,
  Text,
  StyleSheet,
  Image,
  ActivityIndicator,
} from "react-native";
import { useTranslation } from "react-i18next";
import { useColors, ThemeColors } from "../../hooks/useColors";
import { spacing } from "../../theme";

const GOOGLE_ICON = require("../../assets/google.png");

interface GoogleButtonProps {
  onPress: () => void;
  loading?: boolean;
}

export const GoogleButton = ({ onPress, loading }: GoogleButtonProps) => {
  const { t } = useTranslation();
  const colors = useColors();
  const styles = createStyles(colors);
  
  return (
    <TouchableOpacity
      style={styles.button}
      onPress={onPress}
      disabled={loading}
    >
      {loading ? (
        <ActivityIndicator color={colors.text} />
      ) : (
        <>
          <Image
            source={GOOGLE_ICON}
            style={styles.icon}
            resizeMode="contain"
          />
          <Text style={styles.text}>{t("auth.signInWithGoogle")}</Text>
        </>
      )}
    </TouchableOpacity>
  );
};

const createStyles = (colors: ThemeColors) => StyleSheet.create({
  button: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.surface,
    borderColor: colors.border,
    borderWidth: 1,
    borderRadius: 4, // Google recommends 4px border radius
    paddingVertical: 12, // Increased padding for better touch target
    paddingHorizontal: spacing.md,
    minHeight: 44, // Minimum touch target size
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: 12, // Consistent spacing from Google guidelines
  },
  text: {
    fontSize: 16,
    color: colors.text,
    fontWeight: "500",
    fontFamily: "System", // Use system font for consistency
  },
});
